// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3ONLD","label":"LabeledBox_label__2q86S"};